var map = {
	"./ApprovalNeeded/approve-dialog.vue": "u8Yq",
	"./ApprovalNeeded/card.vue": "4Su7",
	"./ApprovalNeeded/index.vue": "/Blb",
	"./ApprovalNeeded/items-list.vue": "5zl1",
	"./ApprovalNeeded/reject-dialog.vue": "2E/x",
	"./ApprovalNeeded/user-info.vue": "vFKZ",
	"./CategorySpend/index.vue": "pgOF",
	"./CurrentInvoices/index.vue": "oePj",
	"./CurrentPrograms/index.vue": "T7Wz",
	"./HotelSpend/index.vue": "CquV",
	"./ImmediatePaymentEscrows/index.vue": "dp0g",
	"./InvoicePaymentStatus/index.vue": "1lw4",
	"./News/index.vue": "+aHG",
	"./PaymentsBySupplierType/index.vue": "EO3P",
	"./ProgramBudget/index.vue": "yjLw",
	"./RecentUpdates/card.vue": "yYTH",
	"./RecentUpdates/index.vue": "i2x5",
	"./SharedComponents/WidgetOptions.vue": "eiQj",
	"./SharedComponents/WidgetSettingsMenu.vue": "XEt1",
	"./Shortcuts/addDivisionModal.vue": "gvZX",
	"./Shortcuts/index.vue": "rR4Q"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "234v";


//////////////////
// WEBPACK FOOTER
// ./src/components/_modules/Dashboard/widgets ^(?!.*(?:ignore)).*\.vue$
// module id = 234v
// module chunks = 12